import React from 'react';
import { Button } from '@routific/hive/v5';
import { useTranslation } from 'react-i18next';

interface Props {
  onClick: () => void;
}

const UnpublishCancelButton: React.FC<Props> = ({ onClick }) => {
  const { t } = useTranslation('common');

  return (
    <Button
      hierarchy="tertiary"
      size="md"
      onClick={onClick}
      data-cy="unpublish-confirm-modal-cancel-btn"
    >
      {t('cancel')}
    </Button>
  );
};

export default UnpublishCancelButton;
